function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M7.76521 15.9551C10.9748 15.5956 13.547 13.0299 13.9131 9.82031C14.3936 5.62366 11.1317 2.05128 7.04289 2.00552V0.12291C7.04289 0.0183201 6.91215 -0.037243 6.8239 0.0281254L2.94756 2.87492C2.88219 2.92395 2.88219 3.01873 2.94756 3.06776L6.8239 5.91455C6.91215 5.97992 7.04289 5.92109 7.04289 5.81977V3.94042C9.91583 3.98618 12.2168 6.43096 12.0207 9.35293C11.854 11.8663 9.8047 13.9058 7.29129 14.066C4.62752 14.2359 2.36251 12.3337 1.95722 9.81704C1.88205 9.34966 1.4735 9.00974 1.00285 9.00974C0.417798 9.00974 -0.0397807 9.52942 0.0517351 10.1079C0.62044 13.6934 3.93135 16.3833 7.76521 15.9551Z",
  fill: "#8295A6"
});

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.0410eb46.svg";
export { ForwardRef as ReactComponent };